import React from "react";

export default function Err() {
  return (
    <div className="">
      <div className="">
        <h1>Error</h1>
      </div>
    </div>
  );
}
